@if(isHeadersAvailable() && !newHeader()) {
  <div class="h-100 overflow-hidden">
    <div class="content-block-main ps-0">
      <div class="headers-body cards-groups gap-20 column-gap-20">
        <mat-list class="flexbox-row w-100 mat-list-base flex-wrap header-list">
          @for (header of filteredHeadersData(); track header.FirmheaderID; let i = $index) {
            <mat-list-item 
              [class.selected-item]="i === selectedItem" (click)="selectItem(i,header)">
              <div class="card flex-1 add-card-header-height">

                <div class="card-header d-flex flex-row align-items-center justify-content-between border-0">
                  <div class="w-100">
                    <div class="">
                      <ng-container *ngIf="!header.isHeaderEdit">
                        <div class="d-flex flex-row align-items-center justify-content-between">
                          <span class="flex-row d-flex hover-action fw-semibold">
                            <p title="{{header.headername}}" class="text-ellipse w-200 fw-semibold header-name">
                              {{ getFormattedName(header.headername) }}
                              <button mat-button class="button-medium-icon-action hover-action-item"
                                (click)="validateUnsavedChanges(header, 'edit'); $event.stopPropagation();">
                                <i class="fa-regular fa-pen fs-15"></i>
                              </button>
                            </p>
                          </span>

                          <ng-container *ngIf="header.isuserselected === 1">
                            <p class="Progress badge badge-In badge-pills badge-small">Default</p>
                          </ng-container>
                          <ng-container *ngIf="header.isuserselected !== 1">
                            <mat-slide-toggle [checked]="header.isuserselected === 1"
                              (click)="validateUnsavedChanges(header, 'selection')">
                              <p class="fw-semibold">Set as Default</p>
                            </mat-slide-toggle>
                          </ng-container>
                        </div>

                      </ng-container>

                      <ng-container *ngIf="header.isHeaderEdit">
                        <div class="flexbox-row justify-content-between w-100">
                          <div class="d-block">
                            <mat-form-field class="fixed-label input-field-editable icon-form-after action-2"
                              floatLabel="always">
                              <input matInput placeholder="Enter header name" #headerName [(ngModel)]="header.headername"
                                (blur)="onHeaderBlur($event,buttonSection,header);$event.preventDefault()">
                              <div matSuffix class="actions border-left" #buttonSection>
                                <button mat-button color="success" (click)="saveHeaderName(header);$event.stopPropagation();">
                                  <i class="fa-regular fa-check"></i>
                                </button>
                                <button mat-button color="cancel" (click)="closeHeader(header);$event.stopPropagation();">
                                  <i class="fa-regular fa-xmark clear-icon"></i>
                                </button>
                              </div>
                            </mat-form-field>
                            <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
                          </div>
                          <div>
                            <ng-container *ngIf="header.isuserselected === 1">
                              <p class="Progress badge badge-In badge-pills badge-small">Default</p>
                            </ng-container>
                            <ng-container *ngIf="header.isuserselected !== 1">
                              <mat-slide-toggle [checked]="header.isuserselected === 1"
                                (click)="validateUnsavedChanges(header, 'selection')">
                                <p class="fw-semibold">Set as Default</p>
                              </mat-slide-toggle>
                            </ng-container>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
                <div class="card-body pt-1 pb-3">
                  <div class="image-sign-height flexbox-row">                    
                      <img [src]="(header.resized_JsonFilePath$ | async) || (header.s3JSONFilePath$ | async)" loading="lazy"  alt="Header Preview"/>
                  </div>
                </div>
                <div class="card-footer d-flex flex-row align-items-center gap-3 justify-content-between border-top py-2">
                  <div class="float-left">
                    <mat-checkbox [checked]="header.is_stretch_fit === 1"
                      (change)="onCheckboxChange($event,header)">Stretch to Fit</mat-checkbox>
                  </div>
                  <div class="button-group gap-16">
                    <button mat-button mat-stroked-button color="primary" class="button-default-icon border-none"
                      [class.selected]="header.picture_alignment === 'left'" (click)="changeAlignment(header,'left')"
                      [disabled]="header.is_stretch_fit === 1">
                      <span class="flexbox-row gap-8">
                        <i class="fa-regular fa-align-left fs-20"></i>
                      </span>
                    </button>
                    <button mat-button mat-stroked-button color="primary" class="button-default-icon border-none"
                      [class.selected]="header.picture_alignment === 'center'" (click)="changeAlignment(header,'center')"
                      [disabled]="header.is_stretch_fit === 1">
                      <span class="flexbox-row gap-8">
                        <i class="fa-regular fa-align-center fs-20"></i>
                      </span>
                    </button>
                    <button mat-button mat-stroked-button color="primary" class="button-default-icon border-none"
                      [class.selected]="header.picture_alignment === 'right'" (click)="changeAlignment(header,'right')"
                      [disabled]="header.is_stretch_fit === 1">
                      <span class="flexbox-row gap-8">
                        <i class="fa-regular fa-align-right fs-20"></i>
                      </span>
                    </button>
                    <button mat-button mat-stroked-button color="primary" class="button-default-icon border-none"
                      (click)="validateUnsavedChanges(header, 'delete')" [disabled]="header.isuserselected === 1">
                      <i class="fa-regular fa-trash fs-20"></i>
                    </button>
                  </div>

                </div>

              </div>
            </mat-list-item>
          }
        </mat-list>
      </div>
      <!-- search results page -->
      <ng-container *ngIf="headersData.length === 0 && !headersDataLoading">
        <div class="no-data-found">
          <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
          <h4>No results found</h4>
          <p class="fs-18 text-gray-6">Sorry, we couldn’t find a match for <br>your query.</p>
          <p class="fs-18 text-gray-6">Please try another search</p>
        </div>
      </ng-container>
    </div>
  </div>
}

@if(!isHeadersAvailable() && !newHeader()){
  <div class="card h-100">
    <div class="no-data-found">
      <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon">
      <h6>No Header Added</h6>
      <p>You have not added any headers.</p>
      <p>Please click on the button to add headers</p>
      <button mat-button mat-flat-button color="primary" class="button-default" (click)="onAddClick();$event.stopPropagation();">
        <div class="flexbox-row gap-8">
          <i class="fa-solid fa-plus"></i>
          <span class="button-label">Add Header</span>
        </div>
      </button>
    </div>
  </div>
}


@if(newHeader()){
  <div class="component-settings w-100 page-wraper">
    <div class="card p-4 gap-22 component-settings-body-headers" style="height: auto;">
      <h6 class="title">Add Header</h6>
     
        <div class="file-upload w-100 bg-white hover-action postion-relative" appDragDrop
          (onFileDropped)="uploadHeader($event, 'dnd')">
          <div class="upload-icon">
            <i class="fa-regular fa-cloud-arrow-up"></i>
          </div>
          <div class="file-wrapper">
            <input type="file" #csvReader name="photo" id="photo" accept="image/*"
              (change)="uploadHeader($event, 'manual')" />
            <p class="text-link text-primary fw-medium m-0">Click to upload <span class="text-gray-6 fw-regular">or drag
                and drop</span></p>
            <p class="fs-12 text-center text-gray-6 fw-regular">PNG, JPG or GIF</p>
          </div>
        </div>
        <!-- <button mat-button mat-stroked-button color="dark" class="close button-medium-icon position-absolute butt-cross-position"
                 (click)="newHeader = false">
                  <i class="fa-regular fa-xmark clear-icon"></i>
                </button> -->
        <div class="mt-3 gap-16">
          <p class="mb-3"><span class="fw-bold">File Type:</span> Upload JPG, PNG, or GIF.</p>
          <p class="mb-3"><span class="fw-bold">File Size Limit:</span> Must be under 5 MB.</p>
          <p class="mb-3"><span class="fw-bold">Recommended Resolution:</span> 720x200 px at 150+ dpi for best clarity.</p>
          <p class="mb-3"><span class="fw-bold">Automatic Resizing:</span> Images will be resized if needed; large images may lose detail when scaled down.</p>
          <p class="mb-3"><span class="fw-bold">Design Tip:</span> Start with a 720x200 px canvas at 150+ dpi to ensure quality.</p>
          <p class="mb-3"><span class="fw-bold"> Preview: </span> Check the preview after uploading. Re-upload if adjustments are needed.</p>
        </div>
        <span class="d-flex justify-content-end">
          <button mat-button mat-stroked-button color="dark" class="button-default upload-cancel-btn"
            (click)="closeNewheader(); $event.stopPropagation();">Cancel</button>
        </span>
      
    </div>
  </div>
}



<ng-template #deleteheaderDialog>
  <div class="countable-dialog confirmation-dailog deleteheaderDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-error badge-circle icon-bordered-error">
        <i class="fa-regular fa-trash-can text-error"></i>
      </span>
      <h4 class="title">Delete Header</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <!-- <p>{{deleteHeaderConfirmationMessage}}</p> -->
      <p>Are you sure you want to delete this header?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark"
        [mat-dialog-close]="false">Cancel</button>
      <button mat-button mat-flat-button class="button-default" color="error" [mat-dialog-close]="true"
        (click)="deleteSelectedHeader()">Delete</button>
    </div>
  </div>
</ng-template>

<!-- Save changes to component? -->
<ng-template #alertUnsavedChangesDialog>
  <div class="countable-dialog confirmation-dailog alertUnsavedChangesDialog" (click)="$event.stopPropagation()">
    <div mat-dialog-title class="dialog-header">
      <span class="badge badge-warning badge-circle icon-bordered-warning">
        <i class="fa-regular fa-triangle-exclamation text-warning"></i>
      </span>
      <h4 class="title">You have unsaved changes</h4>
      <button color="error" class="close" [mat-dialog-close]="false">
        <i class="fa-regular fa-xmark clear-icon"></i>
      </button>
    </div>

    <div mat-dialog-content class="dialog-body-content">
      <p>You are navigating away without saving your changes.</p>
      <p> Do you wish to discard your changes?</p>
    </div>

    <div mat-dialog-actions class="dialog-footer">
      <button mat-button mat-stroked-button class="button-default" color="dark" [mat-dialog-close]
        (click)="saveUnsavedChanges()">No</button>
      <button mat-button mat-flat-button class="button-default" color="primary" [mat-dialog-close]
        (click)="cancelUnsavedChanges()">Yes</button>
    </div>
  </div>
</ng-template>